module.exports = __webpack_public_path__ + "static/media/living_on.810e3a71.png";